
    require(
      "!../../node_modules/gatsby/dist/loaders/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { 
     return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./tags-for-loop.json") })
        }
      }, "path---tags-for-loop");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby/dist/loaders/gatsby-module-loader?name=path---tags-for-loop!./.cache/json/tags-for-loop.json
// module id = ./node_modules/gatsby/dist/loaders/gatsby-module-loader/index.js?name=path---tags-for-loop!./.cache/json/tags-for-loop.json
// module chunks = 45